import { useState } from 'react';
import { uploadFile } from '../lib/files.lib';

export function useUploadFile() {
  const [isUploading, setIsUploading] = useState(false);

  async function handleUpload(file: File) {
    setIsUploading(true);
    try {
      return await uploadFile(file);
    } catch (err) {
      console.log(err);
    } finally {
      setIsUploading(false);
    }
  }

  return { handleUpload, isUploading };
}
